import React, { useEffect, useState } from "react";
import { inject } from "mobx-react";
import { observer } from "mobx-react-lite";
import { ProblemBusiness } from '@business/newCreateRequest/stepsItems/problem';
import { Button, Dialog } from "oned";
import { AmplitudeEventName, StepType } from "@common/enums/base";
import { getCurrentEnv, sendAmplitude_Default } from "@common/utils";
import Cookies from "js-cookie";
var ResidentResponsibility = inject(ProblemBusiness)(observer(function (props) {
    var duplicateCheck = props.duplicateCheck, serviceCategoryId = props.serviceCategoryId, questionNext = props.questionNext, currentUser = props.currentUser;
    var _a = useState(false), cancelRequestVisible = _a[0], setCancelRequestVisible = _a[1];
    var sendAmplitude = function (amplitudeEventName) {
        sendAmplitude_Default(amplitudeEventName, {
            userId: currentUser.userId,
            residentId: currentUser.residentId,
            env: getCurrentEnv(),
            clientId: Cookies.get('clientId'),
            currentStep: currentStep
        });
    };
    useEffect(function () {
        sendAmplitude(AmplitudeEventName.WOCreation_ResidentResponsibility_RSP);
    }, []);
    var currentStep = function () {
        return questionNext ? StepType.Question : StepType.Problem;
    };
    return React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'dsm-card' },
            React.createElement("div", { className: 'dsm-card-body' },
                React.createElement("div", { className: 'py-3 px-20 problem' },
                    React.createElement("div", { className: 'f24' },
                        React.createElement("b", null, "Resident Responsibility")),
                    React.createElement("div", { className: 'mt-4' }, "This maintenance request has been identified as the responsibility of the resident. We can proceed with your work order, but you may be charged for any work done."),
                    React.createElement("div", { className: 'mt-4' }, "If you have any questions, please consult your lease agreement or reach out to your local property management office.")))),
        React.createElement(Button, { type: "secondary", className: "w-100 my-4 dsm-btn-secondary dsm-btn", tag: "requestQuestionsBtn", onClick: function () {
                setCancelRequestVisible(true);
                sendAmplitude(AmplitudeEventName.WOCreation_ResidentResponsibility_cancel_RSP);
            } }, "Cancel"),
        React.createElement(Button, { type: "primary", className: "w-100 dsm-btn-primary dsm-btn", tag: "requestQuestionsBtn", onClick: function () {
                questionNext ? questionNext() : duplicateCheck({ serviceCombo: { serviceCategoryId: serviceCategoryId } });
                sendAmplitude(AmplitudeEventName.WOCreation_ResidentResponsibility_proceed_RSP);
            } }, "Continue"),
        React.createElement(Dialog, { visible: cancelRequestVisible, title: "Cancel Request", closable: true, destroyOnClose: false, onClose: function () { return setCancelRequestVisible(false); }, animation: "zoom", maskAnimation: "fade", hasFooter: false, className: "resident-responsibility", onSubmit: function () {
                setCancelRequestVisible(false);
            } },
            React.createElement("div", { className: 'f24' },
                React.createElement("b", null, "Are you sure you want to cancel?")),
            React.createElement("div", { className: 'f16 mt-4' }, "Canceling this request will redirect you to the homepage. "),
            React.createElement("div", { className: 'mt-4 mb-3 continue-button resident-responsibility-button' },
                React.createElement("a", { href: "/" },
                    React.createElement(Button, { className: "my-4 mr-2 dsm-btn-secondary dsm-btn" },
                        React.createElement("span", { className: 'f14' }, "Yes, cancel"))),
                React.createElement(Button, { className: "my-4 dsm-btn-primary dsm-btn", onClick: function () { return setCancelRequestVisible(false); } },
                    React.createElement("span", { className: 'f14' }, "Continue editing")))));
}));
export default ResidentResponsibility;
